import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faMedium,
  faPinterest,
  // faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Container,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import AuthorizeNet from './AuthorizeNet';

const Footer = () => {
  return (
    <>
      <Box sx={{}} alignItems="center" className="footer" component="footer">
        <Container
          maxWidth="lg"
          sx={{
            px: { xs: 0, md: 2 },
            mx: { xs: -2, sm: 'auto' },
            width: 'auto',
            position: 'relative',
            zIndex: 1,
          }}
        >
          <Grid
            container
            spacing={2}
            m={0}
            sx={{
              pb: { lg: 2, xs: 2 },
              pl: 2,
              my: 0,
              width: '100% !important',
            }}
            //  className="MuiGrid-root-width"
          >
            <Grid size={12} sx={{ pl: { sm: '0 !important' } }}>
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={1}
                alignItems="center"
              >
                <Box component="section" aria-labelledby="about-taxzerone">
                  <Typography
                    variant="h2"
                    id="about-taxzerone"
                    color="white"
                    sx={{
                      fontSize: { lg: 16, md: 16, sm: 16, xs: 16 },
                      fontWeight: 500,
                      my: { xs: 0, sm: 1 },
                    }}
                  >
                    About TaxZerone&#174;
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 1, color: '#909090' }}>
                    TaxZerone&#174; is an IRS-authorized e-file service provider
                    that helps businesses, individuals, and nonprofit
                    organizations file multiple IRS forms, such as business tax,
                    excise tax, employment tax, extension, information returns,
                    and tax-exempt forms, easily and securely.
                  </Typography>
                </Box>
                <Stack
                  spacing={{ xs: 1, sm: 1.5 }}
                  direction="row"
                  justifyContent={{ xs: 'center', sm: 'flex-end' }}
                  alignItems="center"
                  flexWrap={{ xs: 'wrap', sm: 'inherit' }}
                  useFlexGap
                  sx={{
                    width: '100%',
                    textAlign: 'left',
                    mt: 3,
                    maxHeight: { sm: 48 },
                    '& img': {
                      maxHeight: { xs: 42, sm: 60 },
                      width: 'inherit',
                    },
                  }}
                >
                  {/* <Link
                    href="https://trust.taxzerone.com/"
                    target="_blank"
                    sx={{
                      display: 'inline-block',
                      mr: '0 !important',
                    }}
                  > */}
                  <Box
                    sx={{
                      display: 'inline-block',
                    }}
                  >
                    <Tooltip title="TaxZerone SOC2 Compliant" arrow>
                      <picture>
                        <source srcSet="/assets/images/tzo-soc2.webp" />
                        <source srcSet="/assets/images/tzo-soc2.png" />
                        <img
                          src="/assets/images/tzo-soc2.png"
                          loading="lazy"
                          alt="TZO SOC2 Compliant"
                          className="footer-seal-irs"
                          width={70}
                          height={70}
                        />
                      </picture>
                    </Tooltip>
                  </Box>
                  {/* </Link> */}
                  <Link
                    href="https://www.irs.gov/efile-index-taxpros-search?zip=95129&state=6&ero=All&developer=1&transmitter=1"
                    target="_blank"
                    sx={{
                      display: 'inline-block',
                      mr: '0 !important',
                    }}
                  >
                    <Tooltip
                      title="IRS-Authorized E-File Service Provider"
                      arrow
                    >
                      <picture>
                        <source srcSet="/assets/images/irs-authorized.webp" />
                        <source srcSet="/assets/images/irs-authorized.png" />
                        <img
                          src="/assets/images/irs-authorized.png"
                          loading="lazy"
                          alt="IRS-authorized e-file provider"
                          className="footer-seal-irs"
                          width={61}
                          height={60}
                        />
                      </picture>
                    </Tooltip>
                  </Link>
                  <AuthorizeNet />
                  <Link
                    href="https://www.bbb.org/us/ca/san-jose/profile/business-services/taxzerone-llc-1216-1000009558"
                    target="_blank"
                    style={{
                      display: 'inline-block',
                    }}
                  >
                    <Tooltip title="BBB - Accredited Business" arrow>
                      <picture>
                        <source
                          srcSet="/assets/images/BBB_seal.webp"
                          width={168}
                          height={60}
                        />
                        <source
                          srcSet="/assets/images/BBB_seal.png"
                          width={168}
                          height={60}
                        />
                        <img
                          src="/assets/images/BBB_seal.png"
                          loading="lazy"
                          alt="BBB - Accredited Business"
                          className="footer-seal-bbb"
                          width={168}
                          height={60}
                        />
                      </picture>
                    </Tooltip>
                  </Link>
                  <Box
                    sx={{
                      display: 'inline-block',
                    }}
                  >
                    <Tooltip title="CA - Franchise Tax Board" arrow>
                      <picture>
                        <source srcSet="/assets/images/ftb-logo.webp" />
                        <source srcSet="/assets/images/ftb-logo.png" />
                        <img
                          src="/assets/images/ftb-logo.png"
                          loading="lazy"
                          alt="Franchise Tax Board"
                          width={60}
                          height={60}
                        />
                      </picture>
                    </Tooltip>
                  </Box>
                  <Box
                    sx={{
                      display: 'inline-block',
                    }}
                  >
                    <Tooltip title="PCI - DSS Compliant" arrow>
                      <picture>
                        <source srcSet="/assets/images/pci-dss-logo.webp" />
                        <source srcSet="/assets/images/pci-dss-logo.png" />
                        <img
                          src="/assets/images/pci-dss-logo.png"
                          loading="lazy"
                          alt="PCI-DSS"
                          width={76}
                          height={60}
                        />
                      </picture>
                    </Tooltip>
                  </Box>
                </Stack>
              </Stack>
            </Grid>

            <Grid size={12}>
              <Grid container spacing={0} m={0} className="MuiGrid-root-width">
                <Grid
                  size={{ xs: 12, sm: 6, md: 2.5, lg: 2.5 }}
                  sx={{ pt: '0 !important', pl: { sm: '0 !important' } }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      color="white"
                      sx={{
                        fontSize: { lg: 16, md: 16, sm: 16, xs: 16 },
                        fontWeight: 500,
                        mt: 1,
                        mb: 1,
                      }}
                    >
                      Forms
                    </Typography>
                    <ul className="resources-link">
                      <li>
                        <Link
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}employment-tax/`}
                        >
                          Employment Tax Forms
                        </Link>
                      </li>
                      <li>
                        <Link
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/`}
                        >
                          Exempt Org. Forms
                        </Link>
                      </li>

                      <li>
                        <Link
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}information-returns/`}
                        >
                          Information Returns
                        </Link>
                      </li>
                      <li>
                        <Link
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}business-tax/`}
                        >
                          Business Tax Forms
                        </Link>
                      </li>
                      <li>
                        <Link
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-extension/`}
                        >
                          Extension Forms
                        </Link>
                      </li>
                      <li>
                        <Link
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}excise-tax/`}
                        >
                          Excise Tax Forms
                        </Link>
                      </li>
                      <li>
                        <Link
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}efile-boi-report/`}
                        >
                          BOI Report
                        </Link>
                      </li>
                    </ul>
                  </Box>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 1.7, lg: 1.7 }}
                  sx={{ pt: '0 !important' }}
                >
                  <Typography
                    variant="h3"
                    color="white"
                    sx={{
                      fontSize: { lg: 16, md: 16, sm: 16, xs: 16 },
                      fontWeight: 500,
                      mt: 1,
                      mb: 1,
                    }}
                  >
                    Quick Links
                  </Typography>
                  <ul className="resources-link">
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_2290_SITE_URL}`}
                        target="_blank"
                      >
                        Form 2290
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}about-us/`}
                      >
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}faqs/`}
                      >
                        FAQs
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}features/`}
                      >
                        Features
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}free-filing/`}
                      >
                        Free Filing
                      </Link>
                    </li> */}
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}features/click2file/`}
                      >
                        Click2File
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}pricing/`}
                      >
                        Pricing
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}mobile-apps/`}
                      >
                        Apps
                      </Link>
                    </li>
                  </ul>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 2, lg: 2 }}
                  sx={{
                    pt: '0 !important',
                    pl: { sm: '0 !important', md: '16px !important' },
                  }}
                >
                  <Typography
                    color="white"
                    sx={{
                      fontSize: { lg: 16, md: 16, sm: 16, xs: 16 },
                      fontWeight: 500,
                      mt: 1,
                      mb: 0.4,
                      display: { xs: 'none', sm: 'block' },
                    }}
                  >
                    &nbsp;
                  </Typography>
                  <ul className="resources-link">
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}press-releases/`}
                      >
                        Press Releases
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}paystub-generator/`}
                      >
                        Paystub Generator
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}contact-us/`}
                      >
                        Contact Us
                      </Link>
                    </li>
                    <li>
                      <Link
                        href="https://support.taxzerone.com/"
                        target="_blank"
                      >
                        Knowledge Base
                      </Link>
                    </li>

                    {/*<li>
                      <Link href="https://blog.taxzerone.com/" target="_blank">
                        Blog
                      </Link>
                    </li>
                     <li>
                      <Link
                        href="https://www.youtube.com/@taxzerone/videos"
                        target="_blank"
                      >
                        Videos
                      </Link>
                    </li> */}
                    <li>
                      <Link href="https://trust.taxzerone.com/" target="_blank">
                        Trust Center
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}zeronecoins-a-referral-program/`}
                      >
                        ZeroneCoins
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}user-testimonials/`}
                      >
                        User Testimonials
                      </Link>
                    </li>
                  </ul>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 2.8, lg: 2.8 }}
                  sx={{
                    pt: '0 !important',
                    pl: { sm: '0 !important', md: '16px !important' },
                  }}
                >
                  <Typography
                    variant="h3"
                    color="white"
                    sx={{
                      fontSize: { lg: 16, md: 16, sm: 16, xs: 16 },
                      fontWeight: 500,
                      mt: 1,
                      mb: 1,
                    }}
                  >
                    Compare
                  </Typography>
                  <ul className="resources-link">
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/best-form-2290-software/`}
                      >
                        Best Form 2290 Software
                      </Link>
                    </li>

                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/taxzerone-vs-simpletrucktax/`}
                      >
                        TaxZerone vs SimpleTruckTax
                      </Link>
                    </li>

                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/taxzerone-vs-ez2290/`}
                      >
                        TaxZerone vs EZ2290
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/taxzerone-vs-eform2290/`}
                      >
                        TaxZerone vs eForm2290
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/taxzerone-vs-expresstrucktax/`}
                      >
                        TaxZerone vs ExpressTruckTax
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/best-form-941-software/`}
                      >
                        Best Form 941 Software
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/best-form-990-software/`}
                      >
                        Best Form 990 Software
                      </Link>
                    </li>
                  </ul>

                  {/* <Typography
                    variant="h3"
                    color="white"
                    sx={{
                      fontSize: { lg: 16, md: 16, sm: 16, xs: 16 },
                      fontWeight: 500,
                      mt: 3,
                      mb: 1,
                    }}
                  >
                    Tools
                  </Typography>
                  <ul className="resources-link">
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tools/form-2290-tax-calculator/`}
                      >
                        2290 Tax Calculator
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tools/form-7004-due-date-calculator/`}
                        sx={{ whiteSpace: 'nowrap' }}
                      >
                        7004 Due Date Calculator
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={`${process.env.NEXT_PUBLIC_990FINDER_SITE_URL}`}
                        target="_blank"
                      >
                        990 EIN Finder
                      </Link>
                    </li>
                  </ul> */}
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 3, lg: 3 }}
                  sx={{ pt: '0 !important' }}
                >
                  <Box>
                    <Typography
                      color="white"
                      sx={{
                        fontSize: { lg: 16, md: 16, sm: 16, xs: 16 },
                        fontWeight: 500,
                        mt: 1,
                        mb: 0.4,
                        display: { xs: 'none', sm: 'block' },
                      }}
                    >
                      &nbsp;
                    </Typography>

                    <ul className="resources-link">
                      <li>
                        <Link
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/best-form-1099-software/`}
                        >
                          Best Form 1099 Software
                        </Link>
                      </li>
                      <li>
                        <Link
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/taxzerone-vs-tax1099/`}
                        >
                          TaxZerone vs Tax1099
                        </Link>
                      </li>
                      <li>
                        <Link
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/taxzerone-vs-avalara-track1099/`}
                        >
                          TaxZerone vs Track1099 (Avalara)
                        </Link>
                      </li>
                      <li>
                        <Link
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/taxzerone-vs-1099online/`}
                        >
                          TaxZerone vs 1099Online
                        </Link>
                      </li>
                      <li>
                        <Link
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/taxzerone-vs-efile4biz/`}
                        >
                          TaxZerone vs Efile4Biz
                        </Link>
                      </li>

                      <li>
                        <Link
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}comparison/taxzerone-vs-tax2efile/`}
                        >
                          TaxZerone vs Tax2efile
                        </Link>
                      </li>
                    </ul>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Stack
            direction={{ xs: 'column', md: 'row' }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            textAlign="center"
            sx={{
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              borderTopColor: '#333',
              pt: 1,
            }}
          >
            <Box component="span" className="" sx={{ color: '#909090' }}>
              © {new Date().getFullYear()} - TaxZerone LLC. All Rights Reserved.{' '}
              <Box component="span">
                <Box
                  component="br"
                  sx={{
                    ml: 1,
                    display: { xs: 'block', sm: 'none' },
                  }}
                />
                <Link
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}terms-of-use/`}
                  alignItems="center"
                >
                  Terms of Use
                </Link>
                <Box component="span"> | </Box>
                <Link
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}privacy-policy/`}
                  alignItems="center"
                >
                  Privacy Policy
                </Link>
                <Box component="span"> | </Box>
                <Link
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}privacy-policy/#cookie`}
                  alignItems="center"
                >
                  Cookie Policy
                </Link>
              </Box>
            </Box>
            <Box
              sx={{ mt: '8px !important', mb: '8px !important' }}
              className="social-icon"
            >
              <IconButton
                href="https://www.facebook.com/taxzerone"
                aria-label="facebook"
                size="small"
                target="_blank"
                title="facebook"
                sx={{
                  width: { xs: 32, sm: 36 },
                  height: { xs: 32, sm: 36 },
                  boxShadow: '0px 0px 20px rgba(0,0,0,.2)',
                  mx: 1,
                  borderRadius: 3,
                  '&:hover, &:focus, &:active': {
                    background: '#3b5998 !important',
                  },
                }}
                className="white-text"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </IconButton>
              <IconButton
                href="https://www.x.com/TaxZeroneUS"
                aria-label="twitter"
                size="small"
                target="_blank"
                title="twitter"
                sx={{
                  width: { xs: 32, sm: 36 },
                  height: { xs: 32, sm: 36 },
                  boxShadow: '0px 0px 20px rgba(0,0,0,.2)',
                  mx: 1,
                  borderRadius: 3,
                  '&:hover, &:focus, &:active': {
                    background: '#1DA1F2 !important',
                  },
                }}
                className="white-text"
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fab"
                  data-icon="twitter"
                  className="svg-inline--fa fa-twitter"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                  />
                </svg>
              </IconButton>
              <IconButton
                href="https://www.instagram.com/taxzerone/"
                aria-label="instagram"
                size="small"
                target="_blank"
                title="instagram"
                sx={{
                  width: { xs: 32, sm: 36 },
                  height: { xs: 32, sm: 36 },
                  boxShadow: '0px 0px 20px rgba(0,0,0,.2)',
                  mx: 1,
                  borderRadius: 3,
                  '&:hover, &:focus, &:active': {
                    background: '#E1306C !important',
                  },
                }}
                className="white-text"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </IconButton>
              <IconButton
                href="https://www.linkedin.com/company/taxzerone"
                aria-label="linkedin"
                size="small"
                target="_blank"
                title="linkedin"
                sx={{
                  width: { xs: 32, sm: 36 },
                  height: { xs: 32, sm: 36 },
                  boxShadow: '0px 0px 20px rgba(0,0,0,.2)',
                  mx: 1,
                  borderRadius: 3,
                  '&:hover, &:focus, &:active': {
                    background: '#0A66C2 !important',
                  },
                }}
                className="white-text"
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </IconButton>
              <IconButton
                href="https://www.youtube.com/@taxzerone"
                aria-label="youtube"
                size="small"
                target="_blank"
                title="youtube"
                sx={{
                  width: { xs: 32, sm: 36 },
                  height: { xs: 32, sm: 36 },
                  boxShadow: '0px 0px 20px rgba(0,0,0,.2)',
                  mx: 1,
                  borderRadius: 3,
                  '&:hover, &:focus, &:active': {
                    background: '#FF0000 !important',
                  },
                }}
                className="white-text"
              >
                <FontAwesomeIcon icon={faYoutube} />
              </IconButton>
              <IconButton
                href="https://www.pinterest.com/taxzerone/"
                aria-label="pinterest"
                size="small"
                target="_blank"
                title="pinterest"
                sx={{
                  width: { xs: 32, sm: 36 },
                  height: { xs: 32, sm: 36 },
                  boxShadow: '0px 0px 20px rgba(0,0,0,.2)',
                  mx: 1,
                  borderRadius: 3,
                  '&:hover, &:focus, &:active': {
                    background: '#E60023 !important',
                  },
                }}
                className="white-text"
              >
                <FontAwesomeIcon icon={faPinterest} />
              </IconButton>
              <IconButton
                href="https://medium.com/@taxzerone"
                aria-label="medium"
                size="small"
                target="_blank"
                title="medium"
                sx={{
                  width: { xs: 32, sm: 36 },
                  height: { xs: 32, sm: 36 },
                  boxShadow: '0px 0px 20px rgba(0,0,0,.2)',
                  mx: 1,
                  borderRadius: 3,
                  '&:hover, &:focus, &:active': {
                    background: '#000 !important',
                  },
                }}
                className="white-text"
              >
                <FontAwesomeIcon icon={faMedium} />
              </IconButton>
            </Box>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default Footer;
